import { forwardRef } from 'react'
import { LinkedinLogo, type IconProps } from '@phosphor-icons/react'

/**
 * LinkedIn brand mark — always rendered filled for legibility at small sizes.
 * Drop-in for `LinkedinLogo` in icon maps where the render site bakes a single
 * weight for every node icon; the trailing `weight="fill"` overrides whatever
 * weight the caller passes, so the brand mark stays solid everywhere.
 */
export const LinkedInBrandIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <LinkedinLogo ref={ref} {...props} weight="fill" />
))
LinkedInBrandIcon.displayName = 'LinkedInBrandIcon'
